import React from "react";
import Switch from "react-switch";

import collapsed from "./../../../UI/general/collapse.svg";
import pill from "./../../../UI/general/pill.svg";
import close from "./../../../UI/general/close.svg";

/*eslint-disable*/

interface Props {
  colorsData: any;
  inmueblesData: any;
  attributesFilterObject: any;
  handleUpdateFilterObject: any;
  avalabilityAttributesToShow: any;
  handleFilterAvailability: any;
  isDetailed: any;
  handleCloseDetailedSpin: any;
  hasDispo: boolean;
}

interface State {
  isCollapsed: boolean;
  showDispo: boolean;
  showAttributes: boolean;
  currentDropdownOpened: number;
  filteredDropdownAttributes: any;
  isDetailed: boolean;
  wordToShow: any;
}

class SidebarPropertiesMobile extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isCollapsed: false,
      showDispo: true,
      showAttributes: true,
      currentDropdownOpened: -1,
      filteredDropdownAttributes: [],
      isDetailed: false,
      wordToShow: "",
    };
  }

  componentDidMount(): void {
    this.props.inmueblesData.properties.attributes.map((attribute: any) => {
      if (attribute.type === "Hierarchical" && attribute.padre !== null) {
        this.setState({
          wordToShow: attribute.name,
        });
      }

      return 0;
    });
    var filteredAttributes: any = {};

    this.props.inmueblesData.properties.attributes.map(
      (attribute: any, index: number) => {
        filteredAttributes[attribute.id] = [];
      }
    );

    this.setState({
      filteredDropdownAttributes: filteredAttributes,
    });

    if (this.props.isDetailed.group) {
      this.setState({
        isDetailed: true,
      });
    }
  }

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>,
    snapshot?: any
  ): void {
    if (
      this.props.isDetailed !== prevProps.isDetailed &&
      this.props.isDetailed.group
    ) {
      this.setState({
        isDetailed: true,
      });
    }
  }

  handleHideMenus = () => {
    this.setState({
      currentDropdownOpened: -1,
    });
  };

  handleChangeValueDropdown = (
    attributeId: string,
    filterValue: string,
    filterName: string
  ) => {
    if (
      this.props.attributesFilterObject[attributeId].includes(filterValue) ===
      false
    ) {
      this.props.attributesFilterObject[attributeId].push(filterValue);
      this.props.handleUpdateFilterObject(this.props.attributesFilterObject);
      this.state.filteredDropdownAttributes[attributeId].push(filterName);
      this.setState({
        filteredDropdownAttributes: this.state.filteredDropdownAttributes,
      });
    } else if (
      this.props.attributesFilterObject[attributeId].includes(filterValue)
    ) {
      this.props.attributesFilterObject[attributeId].splice(
        this.props.attributesFilterObject[attributeId].indexOf(filterValue),
        1
      );
      this.props.handleUpdateFilterObject(this.props.attributesFilterObject);
      this.state.filteredDropdownAttributes[attributeId].splice(
        this.state.filteredDropdownAttributes[attributeId].indexOf(filterValue),
        1
      );
      this.setState({
        filteredDropdownAttributes: this.state.filteredDropdownAttributes,
      });
    }
    if (filterValue === "") {
      this.props.attributesFilterObject[attributeId] = [];
      this.props.handleUpdateFilterObject(this.props.attributesFilterObject);
      this.state.filteredDropdownAttributes[attributeId] = [];
      this.setState({
        filteredDropdownAttributes: this.state.filteredDropdownAttributes,
      });
    }
  };

  render(): React.ReactNode {
    return (
      <div className="sidebar-properties-general-container">
        {this.state.isDetailed ? (
          <div
            className="detailed-flag"
            style={{
              top: this.state.isCollapsed
                ? "-150%"
                : !this.state.showAttributes
                ? "-75%"
                : "-30%",
            }}
          >
            <div
              className="detailed-close-container"
              onClick={() => {
                this.setState({ isDetailed: false });
                this.props.handleCloseDetailedSpin();
              }}
            >
              <img src={close} alt="" />
            </div>
            <hr />
            {this.props.isDetailed.group ? (
              <div className="detailed-group-name">
                {this.props.isDetailed.group.replace(
                  /\d+/g,
                  (match: any) => ` ${match} `
                )}
              </div>
            ) : null}
          </div>
        ) : null}
        <div
          className="sidebar-properties-pill-container"
          onClick={() => {
            this.setState({ isCollapsed: !this.state.isCollapsed });
          }}
        >
          <img src={pill} alt=""></img>
        </div>
        <hr />
        <div
          className={
            this.state.isCollapsed
              ? "sidebar-properties-options-collpased"
              : "sidebar-properties-options-opened"
          }
        >
          <div className="properties-dispo-container">
            {this.props.hasDispo ? (
              <div
                className="propeties-dispo-show-btn"
                onClick={() => {
                  this.setState({ showDispo: !this.state.showDispo });
                }}
              >
                <div>{"DISPONIBILIDAD"}</div>
                <img src={collapsed} alt=""></img>
              </div>
            ) : null}
            {this.state.showDispo && this.props.hasDispo ? (
              <div className="dispo-switch-container">
                <div className="dispo-option">
                  <Switch
                    checked={this.props.avalabilityAttributesToShow.includes(
                      "DISPONIBLE"
                    )}
                    onChange={() => {
                      this.props.handleFilterAvailability("DISPONIBLE");
                    }}
                    onColor="#96EAA1"
                    checkedIcon={false}
                    uncheckedIcon={false}
                    onHandleColor="#5AE26C"
                    height={12}
                    width={25}
                    handleDiameter={16}
                    className="switch-mobile"
                  />
                  <div>Disponible</div>
                </div>
                <div className="dispo-option">
                  <Switch
                    checked={this.props.avalabilityAttributesToShow.includes(
                      "RESERVADO"
                    )}
                    onChange={() => {
                      this.props.handleFilterAvailability("RESERVADO");
                    }}
                    onColor="#FFAA28"
                    checkedIcon={false}
                    uncheckedIcon={false}
                    onHandleColor="#FFBF4F"
                    height={12}
                    width={25}
                    handleDiameter={16}
                    className="switch-mobile"
                  />
                  <div>Reservado</div>
                </div>
                <div className="dispo-option">
                  <Switch
                    checked={this.props.avalabilityAttributesToShow.includes(
                      "VENDIDO"
                    )}
                    onChange={() => {
                      this.props.handleFilterAvailability("VENDIDO");
                    }}
                    onColor="#EB9797"
                    checkedIcon={false}
                    uncheckedIcon={false}
                    onHandleColor="#EE3F3F"
                    height={12}
                    width={25}
                    handleDiameter={16}
                    className="switch-mobile"
                  />
                  <div>Vendido</div>
                </div>
                <div className="dispo-option">
                  <Switch
                    checked={this.props.avalabilityAttributesToShow.includes(
                      "NO DISPONIBLE"
                    )}
                    onChange={() => {
                      this.props.handleFilterAvailability("NO DISPONIBLE");
                    }}
                    onColor="#A6A6A6"
                    checkedIcon={false}
                    uncheckedIcon={false}
                    onHandleColor="#434343"
                    height={12}
                    width={25}
                    handleDiameter={16}
                    className="switch-mobile"
                  />
                  <div>No disponible</div>
                </div>
              </div>
            ) : null}
          </div>
          <hr />
          <div className="properties-attributes-container">
            <div
              className="propeties-attributes-show-btn"
              onClick={() => {
                this.setState({ showAttributes: !this.state.showAttributes });
              }}
            >
              <div>{"FILTRAR POR ATRIBUTOS"}</div>
              <img src={collapsed} alt=""></img>
            </div>
            {this.state.showAttributes ? (
              <div className="atrtibutes-options-container">
                {this.props.inmueblesData.properties.attributes.map(
                  (attribute: any, index: number) =>
                    attribute.active === 1 ? (
                      <React.Fragment>
                        <div className="attrbiute-option-container-mobile">
                          <div className="attribute-option-individual-mobile">
                            <div className="attrbiute-option-name-mobile">
                              {attribute.name}
                            </div>
                            <div
                              className="attribute-option-btn-mobile"
                              onClick={
                                this.state.currentDropdownOpened === index
                                  ? () => {
                                      this.setState({
                                        currentDropdownOpened: -1,
                                      });
                                    }
                                  : () => {
                                      this.setState({
                                        currentDropdownOpened: index,
                                      });
                                    }
                              }
                              style={{
                                backgroundColor:
                                  this.state.currentDropdownOpened === index
                                    ? this.props.colorsData.main_buttons
                                    : "none",
                                color:
                                  this.state.currentDropdownOpened === index
                                    ? this.props.colorsData.secondary_text
                                    : "#000",
                              }}
                            >
                              {this.props.attributesFilterObject !==
                                undefined &&
                              this.props.attributesFilterObject[
                                attribute.id
                              ] !== undefined &&
                              this.props.attributesFilterObject[attribute.id]
                                .length === 0
                                ? "Todos"
                                : this.props.attributesFilterObject[
                                    attribute.id
                                  ] !== undefined &&
                                  this.props.attributesFilterObject[
                                    attribute.id
                                  ].length > 1
                                ? "Varios"
                                : this.state.filteredDropdownAttributes[
                                    attribute.id
                                  ]}
                            </div>
                          </div>
                        </div>
                        <div className="attribute-dropdown-container">
                          {this.state.currentDropdownOpened === index ? (
                            <div className="attribute-option-dropdown">
                              <div className="attribute-option-general-container-all">
                                <input
                                  type="checkbox"
                                  checked={
                                    this.props.attributesFilterObject[
                                      attribute.id
                                    ].length === 0
                                  }
                                  onChange={() => {
                                    this.handleChangeValueDropdown(
                                      attribute.id,
                                      "",
                                      ""
                                    );
                                  }}
                                ></input>
                                <div>Seleccionar todos</div>
                              </div>
                              <hr></hr>
                              {attribute.values.map(
                                (value: any, indexValue: number) => (
                                  <div
                                    className="attribute-option-general-container"
                                    style={{
                                      marginBottom:
                                        attribute.values.length === indexValue
                                          ? "3%"
                                          : 0,
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      onChange={() => {
                                        this.handleChangeValueDropdown(
                                          attribute.id,
                                          value.value,
                                          value.value
                                        );
                                      }}
                                      data-type={"FILTRO"}
                                      data-value={value.id}
                                      checked={this.props.attributesFilterObject[
                                        attribute.id
                                      ].includes(value.value)}
                                    ></input>
                                    <div>{value.value}</div>
                                  </div>
                                )
                              )}
                              <div className="finish-dropdown"></div>
                            </div>
                          ) : null}
                        </div>
                      </React.Fragment>
                    ) : null
                )}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default SidebarPropertiesMobile;
